import { IOS_PHONE, PHONE } from "constants/deviceInfo";
import { getDevice } from "hooks/useDeviceInfo";
import { isInkleMobileApp } from "util/isInkleMobileApp";

// On phones and the mobile app, download in the same tab instead of a new one.
export function openDownloadUrl(url: string): void {
  const device = getDevice(navigator.userAgent);
  const isMobileDevice = device === PHONE || device === IOS_PHONE;

  if (isInkleMobileApp() || isMobileDevice) {
    window.location.href = url;
    return;
  }

  window.open(url);
}
